export const formatNumber = (number?: any, decimals?: number) => {
  if (!number && number !== 0) {
    return '-'
  }

  if (typeof number !== 'number') {
    return '-'
  }

  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: typeof decimals === 'number' ? decimals : 2,
    maximumFractionDigits: typeof decimals === 'number' ? decimals : 2
  }).format(number)
}
